import _asyncToGenerator from "F:/Lee/Desktop/0206/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "F:/Lee/Desktop/0206/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
export default {
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapState(["sysinfo"])),
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    ontel: function ontel(tel) {
      window.location.href = "tel:" + tel;
    }
  }
};